import { Box } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import { CounterpartyPassportDialog } from "./Passport/CounterpartyPassportDialog";

export function CounterpartyPassportWindowPage() {
    const { id } = useParams();

    // Close window when dialog is closed
    const handleClose = () => {
        window.close();
    };

    return (
        <Box
            sx={{
                height: "100vh",
                width: "100vw",
                padding: 0,
                margin: 0,
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "background.default",
            }}
        >
            <CounterpartyPassportDialog
                open={true}
                onClose={handleClose}
                counterpartyId={id || ""}
            />
        </Box>
    );
}
